import { TimeQuestionConfig, TimeResponseState } from '@gripp/shared-logic';
import { RoutineQuestionModule } from '../types';
import { TimeQuestionAdminForm } from './timeQuestionAdminForm';
import { TimeQuestionExecutionForm } from './timeQuestionExecutionForm';
import { TimeQuestionMessage } from './timeQuestionMessage';

export const TimeQuestionModule: RoutineQuestionModule<
  TimeQuestionConfig,
  TimeResponseState
> = {
  adminForm: TimeQuestionAdminForm,
  executionForm: TimeQuestionExecutionForm,
  message: TimeQuestionMessage,
};
